import { useEffect } from 'react'
import PropTypes from 'prop-types'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import RequestPasswordResetUI from '../../ui/views/RequestPasswordReset'
import { useAuthContext } from '../../auth/AuthProvider'
import useEnhancedFormik from '../../hooks/useEnhancedFormik'
import { requestPasswordResetPropTypes } from '../../common/propTypes'

const RequestPasswordSchema = Yup.object().shape({
  email: Yup.string().email().required(),
})

const RequestPasswordReset = ({ forgotPasswordUsername, onSuccessRequest }) => {
  const {
    sendVerificationCode,
    requestPasswordResetState,
    setDefaultRequestPasswordResetState,
  } = useAuthContext()

  const formik = useFormik({
    validationSchema: RequestPasswordSchema,
    initialValues: {
      email: forgotPasswordUsername ?? '',
    },
    onSubmit: async values => await sendVerificationCode(values.email),
  })

  const enhancedFormik = useEnhancedFormik(
    requestPasswordResetPropTypes,
    formik,
    {
      errors: requestPasswordResetState.error?.code
        ? [requestPasswordResetState.error.code]
        : null,
    },
  )

  useEffect(() => {
    if (requestPasswordResetState?.isSuccess) {
      onSuccessRequest(formik.values.email)
      setDefaultRequestPasswordResetState()
    }
  }, [requestPasswordResetState.isSuccess])

  return (
    <RequestPasswordResetUI
      values={formik.values}
      touched={formik.touched}
      fieldErrors={enhancedFormik.fieldErrors}
      formErrors={enhancedFormik.formErrors}
      onChange={enhancedFormik.handleChange}
      onSubmit={enhancedFormik.handleSubmit}
      onBlur={formik.handleBlur}
      isSendingRequest={requestPasswordResetState.isLoading}
    />
  )
}

RequestPasswordReset.propTypes = {
  forgotPasswordUsername: PropTypes.string,
  onSuccessRequest: PropTypes.func.isRequired,
}

export default RequestPasswordReset
